export default __webpack_public_path__ + "static/media/logo-fpt.3a7b02e8.png";